/* import __COLOCATED_TEMPLATE__ from './sla-breached-config.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import Component from '@glimmer/component';
import { action } from '@ember/object';

interface CustomBotWithBotData {
  botData: {
    get(key: string): unknown;
    set(key: string, value: unknown): void;
  };
}

interface Args {
  customBot: CustomBotWithBotData;
}

interface Signature {
  Args: Args;
  Element: HTMLDivElement;
}

export default class SlaBreachedConfig extends Component<Signature> {
  get slaTargetType() {
    return this.args.customBot.botData.get('slaTargetType');
  }

  @action
  setSlaTargetType(type: string) {
    this.args.customBot.botData.set('slaTargetType', type);
  }
}
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::TriggerInfoNode::SlaBreachedConfig': typeof SlaBreachedConfig;
    'workflows/graph-editor/trigger-info-node/sla-breached-config': typeof SlaBreachedConfig;
  }
}
